import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { notification } from "../../../service/api";

function DashboardHeader() {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role");
  const navigate = useNavigate();

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/employer/login");
  };

  useEffect(() => {
    if (!token) return;

    const fetchNotifications = async () => {
      try {
        const res = await notification();
        const data = res?.data || [];

        setNotifications(data);

        const unread = data.filter((n) => !n.isRead).length;
        setUnreadCount(unread);
      } catch (error) {
        console.error("Failed to fetch notifications", error);
      }
    };

    fetchNotifications();
  }, [token]);

  if (!token) return null;

  return (
    <section
      className="headerSection innerheader wow animate__fadeIn"
      data-wow-delay="0.2s"
    >
      <div className="site-width">
        <div className="headerWrapper">
          <div className="logoSection">
            <a href="/employer/home">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/logoSVG.svg`}
                alt="Hourlee"
                title="Hourlee"
                oncontextmenu="return false;"
              />
            </a>
          </div>
          <div className="headerMain">
            <div className="mainHeader">
              <div className="allHeaders wow animate__fadeIn">
                <div className="mainHeaderSection">
                  <div className="headerNav">
                    <ul class="headerMenu">
                      <li class="hasSub megaMenu">
                        <a href="/employer/candidate-list">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/jobs.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />{" "}
                          Find Candidates
                        </a>
                        <div class="headerSubNav">
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Popular Candidates</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">IT jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">Sales jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Marketing jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Data Science jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">HR jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Engineering jobs
                              </a>
                            </li>
                          </ul>
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Candidates in demand</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Fresher jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">MNC jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">Remote jobs</a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Work from home jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Walk-in jobs
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Part-time jobs
                              </a>
                            </li>
                          </ul>
                          <ul class="headerSubMenu">
                            <li>
                              <h5>Candidates by location</h5>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Delhi
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Mumbai
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Bangalore
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Hyderabad
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Chennai
                              </a>
                            </li>
                            <li>
                              <a href="/employer/candidate-list">
                                Jobs in Pune
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li class="hasSub ">
                        <a href="/employer/candidate-list">
                          <img
                            src={`${process.env.PUBLIC_URL}/assets/img/icons/explore.svg`}
                            alt="chat"
                            style={{ marginRight: "5px" }}
                          />
                          Top Profiles
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="headerButns">
                <div className="headerRightMenuWrap">
                  <ul className="headerRightMenu headerMenu">
                    <li className="hj-megaMenu">
                      <a href="#" className="hj-notification-icon">
                        <i className="fa fa-bell"></i>

                        {unreadCount > 0 && (
                          <span className="hj-notification-count">
                            {unreadCount}
                          </span>
                        )}
                      </a>

                      <div className="hj-headerSubNav">
                        <ul className="hj-headerSubMenu">
                          <li>
                            <h5>Notifications</h5>
                          </li>

                          {notifications.length === 0 && (
                            <li className="hj-empty">No notifications</li>
                          )}

                          {notifications.slice(0, 6).map((item) => (
                            <li
                              key={item._id}
                              className={item.isRead ? "read" : "unread"}
                            >
                              <strong>{item.title}</strong>
                              <p>{item.message}</p>
                              <small>
                                {new Date(item.createdAt).toLocaleString()}
                              </small>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </li>
                    <li className="hasSub">
                      <a href="javascript:void(0)">
                        <i className="fa-regular fa-user"></i> Employer
                      </a>
                      <div className="headerSubNav">
                        <ul className="headerSubMenu">
                          <li>
                            <button
                              type="button"
                              onClick={handleLogout}
                              style={{
                                backgroundColor: "inherit",
                                border: "none",
                                cursor: "pointer",
                              }}
                            >
                              Logout
                            </button>
                          </li>
                        </ul>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="hamburger is-md">
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DashboardHeader;
